export enum SettingsMenuTestIds {
  MENU_ITEM_PREFIX = 'settings-menu-item-',
}
